import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import store from './store';
import ErrorBoundary from 'src/utils/ErrorBoundary';
import SessionQuerys from "./content/applications/SessionQuerys";

const lazyWithRetry = (importFn: () => Promise<any>) =>
  React.lazy(() =>
    importFn().catch(() => {
      window.location.reload();
    })
  );

// Sayfa başarıyla yüklendiğinde chunk reload sayacını sıfırla
sessionStorage.removeItem('chunk_reload_count');

// Async lazy-load chunk hatalarını yakala (router içindeki lazy() çağrıları dahil)
window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  const error = event.reason;
  const isChunkError =
    error?.name === 'ChunkLoadError' ||
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('Loading CSS chunk') ||
    error?.message?.includes('Failed to fetch dynamically imported module') ||
    error?.message?.includes('Importing a module script failed');

  if (isChunkError) {
    const count = parseInt(sessionStorage.getItem('chunk_reload_count') || '0');
    if (count < 3) {
      sessionStorage.setItem('chunk_reload_count', String(count + 1));
      window.location.reload();
    }
  }
});

const App = lazyWithRetry(() => import('./App'));

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <SnackbarProvider
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        maxSnack={3}
        preventDuplicate={false}
        autoHideDuration={3000}
      >
        <Provider store={store}>
          <SessionQuerys>
            <ErrorBoundary>
              <Suspense fallback={null}>
                <App />
              </Suspense>
            </ErrorBoundary>
          </SessionQuerys>
        </Provider>
      </SnackbarProvider>
    </BrowserRouter>
  </HelmetProvider>
);

serviceWorker.unregister();
